// Framework and third-party non-ui
import React, { useContext } from "react";
import { useParams } from "react-router-dom";

// App components
import Hero from "components/Hero";
import Footer from "components/Footer";
import NotificationBanner from "components/NotificationBanner";

// JSON & Styles
import { HomePageLayout } from "./HomePage-styled";
import AppLaunchModal from "components/AppLaunch/AppLaunchModal";
import { MapContext } from "contexts/MapContext";

// Third-party components (buttons, icons, etc.)
const HomePage = () => {
  const { context } = useParams();
  const { showAppLaunchModal } = useContext(MapContext);

  return context === "home" ? (
    <HomePageLayout>
      <NotificationBanner aria-label='Notification Banner' />
      {showAppLaunchModal && <AppLaunchModal />}
      <Hero />
      {/* <FeaturedRoutesTitle aria-label="Featured Routes Title">Featured Routes</FeaturedRoutesTitle>
      {ready ?
        (<>
          <FeaturedRoutesContainer>
            <FeaturedRoutes aria-label="Featured Routes"/>
          </FeaturedRoutesContainer>
        </>) : <ProgressContainer ><CircularProgress /></ProgressContainer>} */}
      <Footer aria-label='Footer' />
    </HomePageLayout>
  ) : null;
};

export default HomePage;
